import { request } from "../../api/api"

export const exportDatabaseDump =(data)=>{
    return request.post("/home/exportDatabaseTableDump/", data)
}